import { render, staticRenderFns } from "./giftdetail.vue?vue&type=template&id=047b31ab&scoped=true&"
import script from "./giftdetail.vue?vue&type=script&lang=js&"
export * from "./giftdetail.vue?vue&type=script&lang=js&"
import style0 from "./giftdetail.vue?vue&type=style&index=0&id=047b31ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b31ab",
  null
  
)

export default component.exports